import {
  ApiError,
  ConflictError,
  ForbiddenError,
  FulfillmentError,
  NotFoundError,
  ValidationError,
} from '../../api/errors';

/** Operator-facing text for a Goods Intake API error; never the raw server message. */
export function intakeErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof FulfillmentError) {
    switch (error.reason) {
      case 'INVALID_STATE':
        return 'The receipt is no longer in a state that allows this. Reload it to see its current state.';
      case 'INACTIVE':
        return 'A stock item or location on this receipt is deactivated. Choose another location.';
      case 'UNKNOWN_REFERENCE':
        return 'A stock item or location doesn’t exist, or the location is at another site.';
      default:
        return fallback;
    }
  }
  if (error instanceof ConflictError) {
    return 'Someone else changed this receipt. Reload it to see their changes; your unsaved counts will be lost.';
  }
  if (error instanceof ForbiddenError) {
    return 'You don’t have permission to receive goods. Sign in with a @tidalx.ai account.';
  }
  if (error instanceof NotFoundError) return 'This receipt no longer exists.';
  if (error instanceof ValidationError) return fallback;
  if (isUnknownOutcome(error)) {
    return 'The server could not be reached. Check the connection and try again.';
  }
  return fallback;
}

export function isUnknownOutcome(error: unknown): boolean {
  return error instanceof ApiError && error.code === 'NETWORK';
}
